import angular from 'angular';

import Component from './calendar-day.component';

const CalendarDay = angular
    .module('control-room.commons.data.components.calendar.components.calendar-day', [])
    .component('crCalendarDay', Component);

export default CalendarDay;
